export default __webpack_public_path__ + "assets/ogg/9a60c62dd1d0f846e5b71327f889d3c3.ogg";